import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
  sources: {
    isBusy: false,
    data: [],
    pagination: {},
    error: null
  }
};

const mutations = {
  LOAD_SOURCES_BUSY: (state, payload) => {
    state.sources.isBusy = payload;
  },
  LOAD_SOURCES_SUCCESS: (state, {data=[], pagination}) => {
    if(pagination && pagination.currentPage === 1) state.sources.data = []
    data.forEach(source => state.sources.data.push(source))
    if(pagination) state.sources.pagination = pagination
    state.sources.error = null;
  },
  LOAD_SOURCES_FAIL: (state, payload) => {
    state.sources.data = null;
    state.sources.error = payload;
  }
};

const actions = {
  getSources: ({ commit, rootState }, { projectId, filterValues, pagination }) => {
    commit('LOAD_SOURCES_BUSY', true);
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    let query = '';
    if(pagination) {
      query = '?';
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }

    return new Promise((resolve, reject) => {
      Axios
        .post(`${API_HOST}/analysis/editor/${projectId}/sources${query}`, filterValues, config)
        .then(({data}) => {
          commit('LOAD_SOURCES_SUCCESS', data.data)
          resolve(data.data.data)
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')});

          console.error(error);
          commit('LOAD_SOURCES_FAIL', error)
          reject()
        })
        .finally(() => commit('LOAD_SOURCES_BUSY', false));
    })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};